module.exports = __webpack_public_path__ + "static/media/Sort-Visualizer.30d20c3c.png";